import type { QuotationConfirmedOrderDto } from '../../lib/quotationApi';

export interface OrderedActions {
  ordered: boolean;
  showConfirm: boolean;
  confirmLabel: string;
  /** Once ordered, the header's actions are secondary: the order is where the work is now. */
  demote: boolean;
}

/**
 * D104.14: what the header still offers once the RFQ has an order. The server (confirmQuotationOrder)
 * tops up an order only from the version it was confirmed from, and refuses another version (409
 * CONFIRMED_ORDER_EXISTS_FOR_RFQ). An order that names no version is read as this one's.
 */
export function orderedActions(
  quotationNumber: string | null | undefined,
  order: QuotationConfirmedOrderDto | null | undefined
): OrderedActions {
  if (!order) return { ordered: false, showConfirm: true, confirmLabel: 'Confirm order', demote: false };
  const orderVersion = (order.quotationNumber || '').trim();
  const sameVersion = !orderVersion || orderVersion === (quotationNumber || '').trim();
  return {
    ordered: true,
    showConfirm: sameVersion,
    confirmLabel: 'Add new lines to order',
    demote: true,
  };
}
